<div class="card" *ngIf="selectedIFFShipmentSummary$ | async as iff">
  <div class="card-header">
    <div class="row align-items-center justify-content-between">
      <div class="col">
        <h5 *ngIf="!isFRTShipment">HHG Shipment Reports Details</h5>
        <h5 *ngIf="isFRTShipment">FRT Shipment Reports Details</h5>
      </div>
      <div class="col-4 col-md-3">
        <div class="row justify-content-end">
          <div class="col-5">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="onExport()"
              [disabled]="disableExport"
            >
              Export to CSV
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body p-5">
    <div class="col-md-3">
      <ul class="list-group">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          SCAC Code
          <span class="badge badge-primary badge-pill">{{ iff.scac }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          SCAC
          <span class="badge badge-primary badge-pill">{{ iff.scacName }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Processing Date
          <span class="badge badge-primary badge-pill">{{
            iff.receivedDate
          }}</span>
        </li>
      </ul>
    </div>
    <div class="col-md-3">
      <ul class="list-group">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Reporting Year
          <span class="badge badge-primary badge-pill">{{
            iff.reportingYear
          }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Reporting Quarter
          <span class="badge badge-primary badge-pill">
            {{ iff.reportingQuarter }}</span
          >
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Status
          <span class="badge badge-primary badge-pill">{{ iff.status }}</span>
        </li>
      </ul>
    </div>
    <div class="col-md-3">
      <ul class="list-group">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Type of Transportation
          <span class="badge badge-primary badge-pill">{{
            iff.transportationType
          }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Number Of Shipments
          <span class="badge badge-primary badge-pill">{{
            iff.numberOfShipments
          }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          {{ getPassThruAmountHeader() }}
          <span class="badge badge-primary badge-pill">{{
            iff.passThruAmount
          }}</span>
        </li>
      </ul>
    </div>
    <div class="col-md-3">
      <ul class="list-group">
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Gross Amount
          <span class="badge badge-primary badge-pill">{{
            iff.grossAmount
          }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Net Amount
          <span class="badge badge-primary badge-pill">{{
            iff.netAmount
          }}</span>
        </li>
        <li
          class="list-group-item d-flex justify-content-between align-items-center"
        >
          Total IFF
          <span class="badge badge-primary badge-pill">{{ iff.totalIFF }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
